import { createAsyncThunk } from '@reduxjs/toolkit';

import { updatePartner } from '@/modules/partner/actions/actions';
import { PaymentInfoForm } from '@/modules/partner/model/form';
import { ThunkResult } from '@/shared/actions/thunk-result';

import { onboardingAPI, ISubmitFormResult } from '../api';
import { isStepAccepted } from '../model/stepErrors';
import { namespace } from '../namespace';

let lastRequestId: string | undefined;

const submitPaymentInfoStep = createAsyncThunk(
  `${namespace}/submit-payment-info-step`,
  async (
    formValues: PaymentInfoForm,
    { dispatch, requestId },
  ): Promise<ThunkResult<ISubmitFormResult<PaymentInfoForm>>> => {
    try {
      if (lastRequestId !== undefined) {
        return { isAlreadyExecuted: true };
      }

      lastRequestId = requestId;

      const result = await onboardingAPI.submitPaymentInfoStep(formValues);

      if (isStepAccepted(result)) {
        await dispatch(
          updatePartner({
            paymentAccount: formValues.accountNumber,
            paymentSortCode: formValues.sortCode,
            paymentRoutingNumber: formValues.routingNumber,
            paymentBik: formValues.bik,
            paymentIban: formValues.iban,
            paymentSwift: formValues.swift,
            paymentRasAccount: formValues.rasAccount,
            onboarding: result.onboarding,
            paymentBankName: formValues.bankName,
            paymentKorAccount: formValues.corAccount,
          }),
        );
      }

      return {
        isSucceed: true,
        result,
      };
    } finally {
      lastRequestId = undefined;
    }
  },
);

export { submitPaymentInfoStep };
